import { Action, createReducer, on } from '@ngrx/store';
import {
    loadTicketEmailSettingsFailure,
    loadTicketEmailSettingsSuccess,
    updateTicketEmailSettings
} from 'src/app/root-store/tickets-store/actions/ticket-email-settings.actions';
import { TicketEmailSettingsState } from 'src/app/root-store/tickets-store/state/ticket-email-settings.state';

export const ticketingEmailFeatureKey = 'tickets';

export const initialState: TicketEmailSettingsState = {
    emailSettings: [],
    error: undefined
};

const ticketEmailSettingsReducer = createReducer(
    initialState,

    on(loadTicketEmailSettingsSuccess, (state, action) => ({
        ...state,
        emailSettings: action.settings
    })),

    on(updateTicketEmailSettings, (state, action) => ({
        ...state,
        emailSettings: state.emailSettings.map((setting) => {
            if (setting.id === action.id) {
                return {
                    ...setting,
                    isSet: action.isSet
                };
            } else {
                return setting;
            }
        })
    })),

    on(loadTicketEmailSettingsFailure, (state, action) => ({
        ...state,
        emailSettings: [],
        error: action.error
    }))
);

export function reducer(state: TicketEmailSettingsState | undefined, action: Action) {
    return ticketEmailSettingsReducer(state, action);
}
